import { iconPhasesAnimation, loadingScreen, msLogo } from './HybridspaceLoadingScreen.scss';

export function HybridspaceLoadingScreen(): JSX.Element {
    return (
        <div id="customloadingScreen" className={loadingScreen}>
            <svg
                id="loadingLogo"
                width="128"
                height="128"
                viewBox="0 0 128 128"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={iconPhasesAnimation}
            >
                <defs>
                    <radialGradient
                        id="paint0_radial_3984_10982"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(64.0003 128) rotate(-69.6338) scale(105.468 57.7464)"
                    >
                        <stop offset="0.124165" stopColor="#D59DFF" />
                        <stop offset="0.784303" stopColor="#0078D4" />
                        <stop offset="1" stopColor="#0C59A4" />
                    </radialGradient>
                    <radialGradient
                        id="paint1_radial_3984_10982"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(19.6052 28.444) rotate(20.8775) scale(99.7714 127.097)"
                    >
                        <stop stopColor="#43EFB1" />
                        <stop offset="0.61125" stopColor="#21C6B3" />
                        <stop offset="1" stopColor="#1E8FCF" />
                    </radialGradient>
                    <linearGradient
                        id="paint2_linear_3984_10982"
                        x1="97.939"
                        y1="166.222"
                        x2="9.15979"
                        y2="87.1654"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#A194F4" />
                        <stop offset="1" stopColor="#975ECE" stopOpacity="0" />
                    </linearGradient>
                    <clipPath id="clip0_3984_10982">
                        <rect width="128" height="128" fill="white" />
                    </clipPath>
                    <clipPath id="clip1_3984_10982">
                        <rect
                            width="128"
                            height="128"
                            fill="white"
                            transform="translate(0 0.000488281)"
                        />
                    </clipPath>
                </defs>
                <g clipPath="url(#clip0_3984_10982)">
                    <g clipPath="url(#clip1_3984_10982)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M62.5 127.875V26.0005H110.183C115.144 34.1647 118 43.7485 118 53.9995C118 67.8299 112.801 80.4459 104.25 89.9995H104.299L70.4941 125.231C68.3465 127.47 65.331 128.351 62.5 127.875Z"
                            fill="url(#paint0_radial_3984_10982)"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M64.064 128H64V54.5005C64 39.3127 76.3122 27.0005 91.5 27.0005C103.235 27.0005 113.254 34.3513 117.202 44.6997C112.795 19.308 90.6522 -0.000488281 64 -0.000488281C34.1766 -0.000488281 10 24.1761 10 53.9995C10 67.8297 15.1992 80.4455 23.7496 89.999H23.7008L57.5059 125.231C59.2931 127.093 61.6813 128.016 64.064 128Z"
                            fill="url(#paint1_radial_3984_10982)"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M64.064 128H64V54.5005C64 39.3127 76.3122 27.0005 91.5 27.0005C103.235 27.0005 113.254 34.3513 117.202 44.6997C112.795 19.308 90.6522 -0.000488281 64 -0.000488281C34.1766 -0.000488281 10 24.1761 10 53.9995C10 67.8297 15.1992 80.4455 23.7496 89.999H23.7008L57.5059 125.231C59.2931 127.093 61.6813 128.016 64.064 128Z"
                            fill="url(#paint2_linear_3984_10982)"
                        />
                    </g>
                </g>
            </svg>
            <svg
                id="MSLogo"
                width="99"
                height="22"
                xmlns="http://www.w3.org/2000/svg"
                className={msLogo}
            >
                <g fill="none" fillRule="evenodd">
                    <path
                        d="M34.643 12.075l-.588 1.647h-.034c-.105-.387-.28-.934-.556-1.63l-3.15-7.897h-3.077V16.75h2.03V9.032c0-.476-.01-1.052-.03-1.711-.01-.333-.049-.6-.058-.804h.045c.103.473.21.834.287 1.075l3.776 9.16h1.42l3.748-9.243c.085-.211.175-.622.257-.992h.044c-.048.915-.09 1.75-.095 2.256v7.978h2.165V4.195h-2.956l-3.228 7.88z"
                        fill="#737474"
                    ></path>
                    <path d="M0 20.956h98.148V0H0z"></path>
                    <path
                        fill="#737474"
                        d="M42.866 16.751h2.118V7.752h-2.118zM43.947 3.929c-.349 0-.653.119-.902.353a1.166 1.166 0 00-.378.883c0 .344.126.636.374.865.247.23.552.345.906.345s.66-.115.91-.345c.25-.23.379-.52.379-.865 0-.339-.125-.632-.37-.873a1.262 1.262 0 00-.919-.363M52.477 7.663a5.892 5.892 0 00-1.182-.127c-.971 0-1.838.209-2.574.62-.739.41-1.31.998-1.699 1.745-.386.745-.583 1.615-.583 2.585 0 .85.19 1.631.567 2.318.377.69.91 1.23 1.585 1.602.673.373 1.452.563 2.313.563 1.006 0 1.866-.201 2.554-.597l.027-.017v-1.94l-.089.066c-.312.227-.66.408-1.035.538a3.121 3.121 0 01-1.014.197c-.83 0-1.497-.26-1.982-.772-.485-.513-.73-1.233-.73-2.14 0-.912.255-1.651.761-2.196.504-.544 1.173-.82 1.986-.82.695 0 1.374.236 2.014.702l.09.063V8.011l-.029-.017c-.241-.135-.571-.246-.98-.331M59.452 7.597a2.17 2.17 0 00-1.415.507c-.358.296-.616.7-.814 1.207H57.2V7.753h-2.116v8.999H57.2v-4.603c0-.784.178-1.426.528-1.912.346-.48.806-.723 1.369-.723.19 0 .404.031.636.093.23.063.396.129.493.2l.09.064V7.737l-.034-.014c-.197-.083-.477-.126-.83-.126M66.885 14.465c-.397.499-.996.751-1.779.751-.777 0-1.39-.256-1.823-.766-.435-.51-.655-1.238-.655-2.163 0-.954.22-1.701.655-2.22.433-.516 1.04-.778 1.806-.778.743 0 1.335.25 1.758.744.426.496.642 1.237.642 2.202 0 .977-.203 1.728-.604 2.23m-1.683-6.929c-1.484 0-2.663.435-3.503 1.293-.84.857-1.265 2.044-1.265 3.527 0 1.41.415 2.543 1.235 3.368.82.826 1.936 1.245 3.316 1.245 1.438 0 2.593-.441 3.434-1.31.84-.87 1.265-2.045 1.265-3.493 0-1.433-.4-2.573-1.187-3.394-.789-.82-1.897-1.236-3.295-1.236M74.378 11.471c-.667-.268-1.095-.49-1.27-.66-.17-.165-.257-.398-.257-.693 0-.262.108-.472.327-.642.219-.17.526-.257.911-.257.357 0 .723.056 1.085.166.363.111.682.26.949.44l.088.06V7.928l-.035-.015a4.715 4.715 0 00-.962-.268 5.932 5.932 0 00-1.056-.109c-1.01 0-1.845.258-2.483.767-.64.512-.967 1.184-.967 1.997 0 .422.07.798.209 1.116.14.32.355.6.641.837.283.233.722.478 1.302.728.488.2.852.37 1.083.505.227.13.387.263.477.39.088.127.133.299.133.512 0 .604-.452.897-1.384.897a3.8 3.8 0 01-1.172-.213 4.418 4.418 0 01-1.2-.609l-.089-.064v2.064l.033.015c.304.14.686.257 1.137.35.449.094.859.141 1.213.141 1.096 0 1.977-.26 2.62-.771.648-.515.976-1.204.976-2.045 0-.607-.176-1.127-.525-1.546-.345-.416-.946-.799-1.784-1.136M84.063 14.465c-.398.499-.997.751-1.78.751-.777 0-1.39-.256-1.822-.766-.435-.51-.655-1.238-.655-2.163 0-.954.22-1.701.655-2.22.432-.516 1.04-.778 1.806-.778.743 0 1.335.25 1.758.744.426.496.642 1.237.642 2.202 0 .977-.204 1.728-.604 2.23M82.38 7.536c-1.484 0-2.663.435-3.503 1.293-.84.857-1.266 2.044-1.266 3.527 0 1.41.415 2.543 1.235 3.368.82.826 1.936 1.245 3.317 1.245 1.438 0 2.593-.441 3.433-1.31.84-.87 1.266-2.045 1.266-3.493 0-1.433-.4-2.573-1.187-3.394-.789-.82-1.897-1.236-3.295-1.236M98.149 9.48V7.752h-2.144V5.069l-.072.022-2.015.616-.038.012v2.034h-3.177V6.62c0-.527.118-.931.351-1.2.23-.266.56-.402.982-.402.303 0 .616.072.931.213l.079.035V3.447l-.037-.013c-.294-.105-.695-.159-1.19-.159-.626 0-1.194.136-1.689.406-.495.27-.886.655-1.16 1.146-.272.489-.41 1.054-.41 1.68v1.246h-1.492v1.726h1.493v7.273h2.142V9.479h3.177v4.622c0 1.903.897 2.868 2.668 2.868.291 0 .597-.034.91-.101.319-.07.535-.137.662-.21l.029-.016v-1.743l-.087.058c-.117.078-.262.14-.432.188-.17.048-.312.072-.422.072-.416 0-.723-.112-.914-.332-.191-.223-.289-.612-.289-1.158V9.48h2.144z"
                    ></path>
                    <path fill="#F05124" d="M0 9.958h9.958V.001H0z"></path>
                    <path fill="#7EBB42" d="M10.995 9.958h9.957V.001h-9.957z"></path>
                    <path fill="#32A0DA" d="M0 20.956h9.958V11H0z"></path>
                    <path fill="#FDB813" d="M10.995 20.956h9.957V11h-9.957z"></path>
                </g>
            </svg>
        </div>
    );
}
